import { Calendar, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface QuoteMetaDateFieldProps {
  label: string;
  value: string;
  readOnly: boolean;
  onChange: (value: string) => void;
}

/** A labeled `yyyy-MM-dd` date picker with a clear button, for the quote meta bar. */
export function QuoteMetaDateField({
  label,
  value,
  readOnly,
  onChange,
}: QuoteMetaDateFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-medium text-muted-foreground flex items-center gap-1">
        <Calendar className="h-3 w-3" />
        {label}
      </label>
      <div className="flex items-center gap-1">
        <div className="relative min-w-0 flex-1">
          <Input
            type="date"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={readOnly}
            className="w-full h-9 pr-9 [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:cursor-pointer"
          />
          <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        </div>
        {value && !readOnly && (
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9 shrink-0 text-muted-foreground"
            onClick={() => onChange("")}
            aria-label={`Clear ${label.toLowerCase()}`}
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
